import React from 'react';
import UserDashboardJobsList from 'components/UserDashboard/UserDashboardJobsList/UserDashboardJobsList';

const UserDashboardHome = () => <UserDashboardJobsList />;

export default UserDashboardHome;
